import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { allRdsData } from "../../RDPageV2/data";
import styles from "./styles.module.scss";
import Button from "../../common/Button";
const RdModule = () => {
    const history = useHistory();
    const myRD = useSelector((state) => state.dietitian);
    const getRdData = allRdsData.find((item) => item.name.toLowerCase() === myRD?.assigned_RD.toLowerCase());
    const goToRd = () => {
        history.push("/app/dietitian/");
    };
    return (_jsxs("div", { className: styles.rd, children: [_jsx("div", { className: styles.img, children: _jsx("img", { src: getRdData && getRdData.img, alt: "" }) }), _jsx("div", { className: styles.title, children: "NEED MORE GUIDANCE?" }), _jsx("div", { className: styles.text, children: "Connect with your Registered Dietitian to discuss your macros and create a plan that works for you and your goals." }), _jsx(Button, { onClick: goToRd, color: "court", children: "Chat Now" })] }));
};
export default RdModule;
